import { gql } from "@/__generated__/gql";

export const UPDATE_BULK_MESSAGE_MUTATION = gql(`
 mutation UpdateBulkMessage(
  $bulkMessageId: ID!
  $draft: Boolean
  $filters: BulkMessageFilterInput
  $messageParts: [MessagePartInput!]
  $name: String
  $sendOption: BulkMessageSendOptionInput
  $sender: BulkMessageSenderInput
) {
  updateBulkMessageMutation(input: {
    bulkMessageId: $bulkMessageId,
    draft: $draft,
    filters: $filters,
    messageParts: $messageParts,
    name: $name,
    sender: $sender,
    sendOption: $sendOption
  }) {
    bulkMessage {
      id
      audienceReach(first: 6) {
        edges {
          node {
            id
            uuid
            firstName
            lastName
            profilePhoto {
              id
              url(size: 48)
            }
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
      draft
    }
    errors {
      title
      message
    }
  }
}
`);
